import { registerActions } from '@/stores/commandPalette';
import { buildNavigationActions } from './navigationActions';
import { buildQuickActions } from './quickActions';

let booted = false;

export function bootCommandPalette(): void {
  if (booted) return;
  booted = true;
  registerActions([...buildNavigationActions(), ...buildQuickActions()]);
}
